<template>
	<div>
		<ModalSearchProdukBinary ref="modalSearchProdukBinary" @action="cari"></ModalSearchProdukBinary>
		<ModalProdukBinaryDetail ref="modalProdukBinaryDetail"></ModalProdukBinaryDetail>
		<v-card class="pa-4 elevation-0 rounded-lg">
			<v-row>
				<v-col cols="12" class="text-right">
					<v-btn depressed color="primary" class="white--text rounded-lg text-capitalize" @click="showSearch">Cari</v-btn>
					<v-btn depressed color="grey lighten-1" class="ml-3 white--text rounded-lg text-capitalize" @click="reset">Reset</v-btn>
				</v-col>
			</v-row>
			<div class="mt-3" v-if="!loading">
				<v-row class="ml-0" v-if="listSerialRegistration.length > 0">
					<v-col cols="12" sm="6" md="4" xl="3" class="pl-0 pt-0" v-for="(serial, i) in listSerialRegistration" :key="i">
						<v-card outlined class="pa-3 elevation-0 rounded-lg hover-shadow" :color="(serial.serial_member_serial_is_used == '1') ? '#f5f5f5' : ''" :disabled="(serial.serial_member_serial_is_used == '1') ? true : false">
							<div class="cursor-pointer badge-serial" @click="detailSerial(serial.serial_member_serial_id)" v-if="false">
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<div v-bind="attrs" v-on="on">
											<v-icon color="blue">mdi-information</v-icon>
										</div>
									</template>
									<span>Detail</span>
								</v-tooltip>
							</div>
							<v-row>
								<v-col cols="6" class="pb-0">
									<div class="font-size-10 cl-grey">Serial</div>
									<div class="font-size-11 cl-primary font-weight-500">{{ serial.serial_member_serial_id }}</div>
								</v-col>
								<v-col cols="6" class="pb-0">
									<div class="font-size-10 cl-grey">Pembelian</div>
									<div class="font-size-10 cl-grey font-weight-500">{{ serial.serial_member_serial_buy_datetime | tanggal }}</div>
								</v-col>
								<v-col md="6" class="pt-2">
									<div class="font-size-10 cl-grey">Status</div>
									<div v-if="serial.serial_member_serial_is_used == '1'">
										<div class="font-size-10 red--text font-weight-500">Telah Digunakan</div>
									</div>
									<div v-else>
										<div class="font-size-10 green--text font-weight-500">Tersedia</div>
									</div>
								</v-col>
								<v-col md="6" class="pt-2">
									<div class="font-size-10 cl-grey">Tanggal Digunakan</div>
									<div class="font-size-10 cl-grey font-weight-500">{{ serial.serial_member_serial_used_datetime | tanggal }}</div>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<div v-else>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="pt-3 elevation-0 rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada data serial yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="mt-3" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</v-card>
		<div class="mt-3" v-if="listSerialRegistration.length > 0">
			<v-row justify="end">
				<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
					<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="serialRegistrationPagination.total_page" @input="changePage"></v-pagination>
				</v-col>
				<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
					<div class=" font-size-10">Menampilkan {{ serialRegistrationPagination.total_display }} data dari total {{ serialRegistrationPagination.total_data }} data</div>
				</v-col>
				<v-col cols="4" sm="2" md="1">
					<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalSearchProdukBinary from './components/ModalSearchProdukBinary';
import ModalProdukBinaryDetail from './components/ModalProdukBinaryDetail';

export default {
	components: {
		ModalSearchProdukBinary, ModalProdukBinaryDetail
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '12',
			listLimit: [ '12', '20', '50', '100' ],
			params: [],
		}
	},
	computed: {
		...mapState('serial', ['listSerialRegistration', 'serialRegistrationPagination']),
	},
	methods: {
		...mapActions('serial', ['getSerialRegistration', 'getDetailSerialRegistration']),

		queryStringSerial(value) {
			let parameterObject = {}
			let parameter = '{'

			if (value.params) {
				value.params.forEach((value, index) => {
					for (const [key, val] of Object.entries(value)) {
						parameter += `"filter[${index}][${key}]":"${val}",`
					}
				})
			}
			parameter += `"serial_type": "${value.serial_type}", "start_type_id": "${value.start_type_id}", "end_type_id": "${value.end_type_id}", "limit": "${value.limit}", "page": "${value.page}", "sort": "${value.sort}", "dir": "${value.dir}"`
			parameter += '}'
			parameterObject = JSON.parse(parameter)
			return parameterObject
		},

		showSearch() {
			this.$refs.modalSearchProdukBinary.modalShow()
		},
		cari(data) {
			this.params = []
			this.page = 1

			if(data.serial.value)
				this.params.push(data.serial)

			if(data.isUsed.value)
				this.params.push(data.isUsed)

			if(data.dateBuy.value)
				this.params.push(data.dateBuy)

			if(data.dateUse.value)
				this.params.push(data.dateUse)

			this.getSerialRegistration(this.queryStringSerial({serial_type: 'bin', start_type_id: 7, end_type_id: 7, limit:this.limit, page: this.page, params: this.params, sort: 'serial_member_serial_is_used', dir: 'asc'}))
				.then(() => {
					this.$refs.modalSearchProdukBinary.modalHide()
				})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		reset() {
			this.page = 1
			this.limit = '12'
			this.params = []
			this.getData()
			this.$refs.modalSearchProdukBinary.reset()
		},
		getData() {
			this.loading = true
			this.getSerialRegistration(this.queryStringSerial({serial_type: 'bin', start_type_id: 7, end_type_id: 7, limit:this.limit, page: this.page, params: this.params, sort: 'serial_member_serial_is_used', dir: 'asc'})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		detailSerial(id) {
			this.getDetailSerialRegistration(id).then(() => {
				this.$refs.modalProdukBinaryDetail.modalShow()
			})
		}
	},
	created(){
		this.getData()
	}
};
</script>

